import { Component, Input } from "@angular/core";
import { KeyboardShortcuts } from "app/js/src/domain/common/keyboard-shortcuts";

@Component({
  selector: "evrideo-evrideo-keyboard-shortcuts",
  templateUrl: "./evrideo-keyboard-shortcuts.component.html",
  styleUrl: "./evrideo-keyboard-shortcuts.component.scss",
})
export class EvrideoKeyboardShortcutsComponent {
  @Input() shortcuts: KeyboardShortcuts;
  public loaded = false;
  public categories = [];
  ngOnInit() {
    this.setupUI();
  }
  ngOnChanges() {
    this.setupUI();
  }

  private setupUI() {
    if (this.shortcuts) {
      this.categories = Object.keys(this.shortcuts);
      this.loaded = true;
    }
  }
}
